import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import ItemsGrid from '../items-grid';
import TeamTile from '../team-tile';

import './styles.css';

export default () => {
    const data = useStaticQuery(graphql`
        query {
            james: file(relativePath: { eq: "headshot-james.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 600, grayscale: true) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            dan: file(relativePath: { eq: "headshot-dan.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 600, grayscale: true) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            dustin: file(relativePath: { eq: "headshot-dustin.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 600, grayscale: true) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            zach: file(relativePath: { eq: "headshot-zach.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 600, grayscale: true) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            ryan: file(relativePath: { eq: "headshot-ryan.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 600, grayscale: true) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            christian: file(relativePath: { eq: "headshot-christian.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 600, grayscale: true) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);
    return (
        <div className="parallax-section">
            <ItemsGrid header="our team">
                <TeamTile
                    image={data.james.childImageSharp.fluid}
                    name="James Ontiveros"
                    title="Co-Founder & CEO"
                />
                <TeamTile
                    image={data.dan.childImageSharp.fluid}
                    name="Dan Mahowald"
                    title="Co-Founder & Chairman"
                />
                <TeamTile
                    image={data.dustin.childImageSharp.fluid}
                    name="Dustin Higginbotham"
                    title="Co-Founder & CTO"
                />
                <TeamTile
                    image={data.christian.childImageSharp.fluid}
                    name="Christian Nitu"
                    title="Co-Founder"
                />
                <TeamTile
                    image={data.zach.childImageSharp.fluid}
                    name="Zach Pierce"
                    title="Lead Engineer"
                />
                <TeamTile
                    image={data.ryan.childImageSharp.fluid}
                    name="Ryan Clark"
                    title="Engineer"
                />
            </ItemsGrid>
        </div>
    );
};
